import { createFileRoute } from '@tanstack/react-router';

import { SelfServicePublicPage } from '@/features/rrhh/components/self-service-public-page';

// Ruta pública SIN auth shell. El trabajador llega con su link de
// WhatsApp/email. Path: /public/rrhh/self-service/:token.
// El root layout (Outlet) no monta sidebar — la página renderiza su
// propio shell mobile-friendly.
export const Route = createFileRoute('/public/rrhh/self-service/$token')({
  component: SelfServiceRoute,
});

function SelfServiceRoute() {
  const { token } = Route.useParams();
  return <SelfServicePublicPage token={token} />;
}
